import styled from 'styled-components';

export const OverlayStyle = styled.div<{ show: boolean }>`
  position: fixed;

  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${(props) => (props.show ? 1 : 0)};
  transition: opacity 0.1s ease-in-out;
  pointer-events: ${(props) => (props.show ? 'auto' : 'none')};
`;
